// extracted by mini-css-extract-plugin
module.exports = {"ctfPageCopy":"join-page_ctfPageCopy__T359I"};